// Mirrors InvoluntaryWithholdingExemptAmount.FILING_STATUS_CHOICES in taxengine/models.py
export default [
    {id: 'single', name: 'Single'},
    {id: 'married-filing-jointly', name: 'Married, Filing Jointly'},
    {id: 'married-filing-separately', name: 'Married, Filing Separately'},
    {id: 'head-of-household', name: 'Head of Household'},
    {id: 'qualified-widow', name: 'Qualified Widow(er)'},
]
